import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import importListHelper from '../../../Helpers/importListHelper';
import UserService from '../../../Services/userService';

export default class ExcludedPayEvaluatorsSearchParams extends SearchParamsBase {
  initialize() {
    this.AssignmentType = 'excluded';
    // CD-5148: was AsSassieAsgnId, which the backend DTO (ProjectAssignmentSearchParameters) has no property for, so
    // the Apollo ID filter was silently dropped. AssignmentApolloIds is the name the excluded repository filters on.
    this.AssignmentApolloIds = '';
    this.ClientNameOrId = '';
    this.ProjectIdOrName = '';
    this.SelectedAssignmentCountryCodes = [];
    this.EvaluatorNameOrId = '';
    this.EvaluatorEmail = '';
    // The backend's fieldwork office (the pricing's office); the project page's Excluded tabs use it too.
    this.SelectedOfficeIds = [];
    this.SelectedPaymentOfficeIds = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'AssignmentApolloIds',
      label: 'Apollo IDs',
      className: 'col-4',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
    },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ProjectIdOrName', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedAssignmentCountryCodes',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'FW Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedPaymentOfficeIds',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'EvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorEmail', label: 'Evaluator Email', className: 'col-6', type: InputTypesEnum.Text },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ExcludedPayEvaluatorsSearchParams';
}
